// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/cash/localization/localization.proto (package squareup.cash.localization, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { Money } from "../../common/currency_pb";
import { file_squareup_common_currency } from "../../common/currency_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file squareup/cash/localization/localization.proto.
 */
export const file_squareup_cash_localization_localization: GenFile = /*@__PURE__*/
  fileDesc("Ci1zcXVhcmV1cC9jYXNoL2xvY2FsaXphdGlvbi9sb2NhbGl6YXRpb24ucHJvdG8SGnNxdWFyZXVwLmNhc2gubG9jYWxpemF0aW9uItwFChFMb2NhbGl6YWJsZVN0cmluZxILCgNrZXkYASABKAkSWgoJYXJndW1lbnRzGAIgAygLMkcuc3F1YXJldXAuY2FzaC5sb2NhbGl6YXRpb24uTG9jYWxpemFibGVTdHJpbmcuTG9jYWxpemFibGVTdHJpbmdBcmd1bWVudBJeCg5tb25leUZvcm1hdHRlchgDIAEoDjI8LnNxdWFyZXVwLmNhc2gubG9jYWxpemF0aW9uLkxvY2FsaXphYmxlU3RyaW5nLk1vbmV5Rm9ybWF0dGVyOghTVEFOREFSRBIQCgh0aW1lem9uZRgEIAEoCRIXCg9sb2NhbGVfb3ZlcnJpZGUYCCABKAkapQIKGUxvY2FsaXphYmxlU3RyaW5nQXJndW1lbnQSDAoEbmFtZRgBIAEoCRIWCgxzdHJpbmdfdmFsdWUYAiABKAlIABIUCgpsb25nX3ZhbHVlGAMgASgDSAASFgoMZG91YmxlX3ZhbHVlGAQgASgBSAASLQoLbW9uZXlfdmFsdWUYBSABKAsyFi5zcXVhcmV1cC5jb21tb24uTW9uZXlIABIhChd0aW1lc3RhbXBfc2Vjb25kc192YWx1ZRgGIAEoA0gAElgKH25lc3RlZF9sb2NhbGl6YWJsZV9zdHJpbmdfdmFsdWUYByABKAsyLS5zcXVhcmV1cC5jYXNoLmxvY2FsaXphdGlvbi5Mb2NhbGl6YWJsZVN0cmluZ0gAQggKBnZhbHVlcyKYAQoOTW9uZXlGb3JtYXR0ZXISHwobTU9ORVlfRk9STUFUVEVSX1VOU1BFQ0lGSUVEEAASDAoIU1RBTkRBUkQQARIOCgpBQ0NPVU5USU5HEAISCAoEQ09ERRADEgsKB0NPTVBBQ1QQBBIQCgxDT01QQUNUX0NPREUQBRIeChpDT01QQUNUX1BPU0lUSVZFX1NJR05fT05MWRAGSgQIBRAGSgQIBhAHSgQIBxAIIowBCg9Mb2NhbGl6ZWRTdHJpbmcSXwoSbG9jYWxpemFibGVfc3RyaW5nGAEgASgLMi0uc3F1YXJldXAuY2FzaC5sb2NhbGl6YXRpb24uTG9jYWxpemFibGVTdHJpbmdCFOL2GRB0cmFuc2xhdGVkX3ZhbHVlEhgKEHRyYW5zbGF0ZWRfdmFsdWUYAiABKAkiagoSVHJhbnNsYXRpb25NZXNzYWdlEhIKCmNsaWVudF9rZXkYASABKAkSDwoHY29udGV4dBgCIAEoCRIMCgRwYXRoGAMgASgJEgwKBHRleHQYBCABKAkSEwoLdmVyc2lvbl9rZXkYBSABKAkibwobTG9jYWxlVG9UcmFuc2xhdGlvbk1lc3NhZ2VzEg4KBmxvY2FsZRgBIAEoCRJACghtZXNzYWdlcxgCIAMoCzIuLnNxdWFyZXVwLmNhc2gubG9jYWxpemF0aW9uLlRyYW5zbGF0aW9uTWVzc2FnZTpTChV0cmFuc2xhdGVkX2ZpZWxkX25hbWUSHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGOyeAyABKAlSE3RyYW5zbGF0ZWRGaWVsZE5hbWVCJwolY29tLnNxdWFyZXVwLnByb3Rvcy5jYXNoLmxvY2FsaXphdGlvbg", [file_google_protobuf_descriptor, file_squareup_common_currency]);

/**
 * Represents a localizable string that can be translated to a different locale with variable arguments replaced inside the string.
 * For newly declared fields that are intended to be human-readable strings, the LocalizedString wrapper should be used instead.
 *
 * This proto should be used for localizing only sync entities / sync values in the ClientSync service,
 * or localizing protos in requests to postmaster for sending localized messages to customers.
 * The above cases are localized automatically by the ClientSync and Postmaster services.
 * If you need to use this proto anywhere else, they will not be localized automatically.
 * Please ask for help in #cash-localization-eng-help.
 *
 * @generated from message squareup.cash.localization.LocalizableString
 */
export type LocalizableString = Message<"squareup.cash.localization.LocalizableString"> & {
  /**
   * Localization key that points to the translated string.
   * The string should be in ICU format. https://en.wikipedia.org/wiki/International_Components_for_Unicode
   * e.g. key could be "clientsync.hello" where the English string is "Hello, {name}!"
   *
   * @generated from field: optional string key = 1;
   */
  key: string;

  /**
   * Map of argument names to values that should be replaced on the localized string. e.g. map of "name" to "Jack"
   * Using a repeated custom message instead of the native map type because Cash iOS does not support it: https://cash.slack.com/archives/C01M5K4DM3P/p1628721166209800?thread_ts=1628720733.202800&cid=C01M5K4DM3P
   *
   * @generated from field: repeated squareup.cash.localization.LocalizableString.LocalizableStringArgument arguments = 2;
   */
  arguments: LocalizableString_LocalizableStringArgument[];

  /**
   * Options for how to format Money parameters
   *
   * @generated from field: optional squareup.cash.localization.LocalizableString.MoneyFormatter moneyFormatter = 3 [default = STANDARD];
   */
  moneyFormatter: LocalizableString_MoneyFormatter;

  /**
   * Option for how to format the timezone portion of Timestamp parameters
   * For timezone, use standard tz database names (https://www.iana.org/time-zones)
   * For convenience: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
   * If timezone is not provided, then timezone is derived from the Time-Zone request header from the client.
   *
   * @generated from field: optional string timezone = 4;
   */
  timezone: string;

  /**
   * Optional locale override. e.g. en-US or es-US.
   * If provided and available, this string is localized to this locale.
   *
   * @generated from field: optional string locale_override = 8;
   */
  localeOverride: string;
};

/**
 * Describes the message squareup.cash.localization.LocalizableString.
 * Use `create(LocalizableStringSchema)` to create a new message.
 */
export const LocalizableStringSchema: GenMessage<LocalizableString> = /*@__PURE__*/
  messageDesc(file_squareup_cash_localization_localization, 0);

/**
 * @generated from message squareup.cash.localization.LocalizableString.LocalizableStringArgument
 */
export type LocalizableString_LocalizableStringArgument = Message<"squareup.cash.localization.LocalizableString.LocalizableStringArgument"> & {
  /**
   * @generated from field: optional string name = 1;
   */
  name: string;

  /**
   * @generated from oneof squareup.cash.localization.LocalizableString.LocalizableStringArgument.values
   */
  values: {
    /**
     * @generated from field: string string_value = 2;
     */
    value: string;
    case: "stringValue";
  } | {
    /**
     * @generated from field: int64 long_value = 3;
     */
    value: bigint;
    case: "longValue";
  } | {
    /**
     * @generated from field: double double_value = 4;
     */
    value: number;
    case: "doubleValue";
  } | {
    /**
     * @generated from field: squareup.common.Money money_value = 5;
     */
    value: Money;
    case: "moneyValue";
  } | {
    /**
     *
     * Was "google.protobuf.Timestamp timestamp_value = 6;"
     * Caused JSON serialization errors in various Cash services as the Timestamp proto is generated to java.time.Instant for Kotlin/Java with Wire.
     * Rather than ensuring that all services are using the correct JSON adapter to serialize the generated proto, we are simplifying the proto instead.
     * See https://cash.slack.com/archives/C02JU5EN33Q/p1675280149224509?thread_ts=1675181697.468959&cid=C02JU5EN33Q
     * We do not need nanosecond precision, only seconds, when displaying formatted time to the customer.
     * Replaced with "int64 timestamp_seconds_value = 6;" at the same field number.
     * Not reserving the field number instead because oneof doesn't support reserved.
     * Not deprecating the field because callers that do JSON serialization will still have the same issue.
     *
     * Represents seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive.
     *
     * @generated from field: int64 timestamp_seconds_value = 6;
     */
    value: bigint;
    case: "timestampSecondsValue";
  } | {
    /**
     *
     * Please use best judgement when choosing to nest localizable strings.
     * Some languages might not be structured in the same way that make it
     * difficult or impossible to translate depending on how it is used.
     *
     * @generated from field: squareup.cash.localization.LocalizableString nested_localizable_string_value = 7;
     */
    value: LocalizableString;
    case: "nestedLocalizableStringValue";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message squareup.cash.localization.LocalizableString.LocalizableStringArgument.
 * Use `create(LocalizableString_LocalizableStringArgumentSchema)` to create a new message.
 */
export const LocalizableString_LocalizableStringArgumentSchema: GenMessage<LocalizableString_LocalizableStringArgument> = /*@__PURE__*/
  messageDesc(file_squareup_cash_localization_localization, 0, 0);

/**
 * These correspond to the formatters available in our MoneyFormatter library.
 * See: https://github.com/squareup/cash-mobile-multiplatform/blob/a6e39335aa617110c7b967e260c2041e1a77bd33/money-formatter/src/commonMain/kotlin/com/squareup/cash/common/moneyformatter/MoneyFormatter.kt#L245
 *
 * @generated from enum squareup.cash.localization.LocalizableString.MoneyFormatter
 */
export enum LocalizableString_MoneyFormatter {
  /**
   * @generated from enum value: MONEY_FORMATTER_UNSPECIFIED = 0;
   */
  MONEY_FORMATTER_UNSPECIFIED = 0,

  /**
   * * Typical display of dollars and cents, e.g. "$25.00" or "¥1,000". 
   *
   * @generated from enum value: STANDARD = 1;
   */
  STANDARD = 1,

  /**
   * * Typical display for an accounting ledger, e.g. "($25.00)" or "$25.00" for negative and positive values, respectively. 
   *
   * @generated from enum value: ACCOUNTING = 2;
   */
  ACCOUNTING = 2,

  /**
   * * Typical display of dollars and cents with currency code, e.g., "USD 25.00" or "1.50000000 BTC". 
   *
   * @generated from enum value: CODE = 3;
   */
  CODE = 3,

  /**
   * * Typical display of dollars only, or dollars and cents, e.g. "$25" or "$24.99". 
   *
   * @generated from enum value: COMPACT = 4;
   */
  COMPACT = 4,

  /**
   * * Typical display of dollars only, or dollars and cents with currency code, e.g. "USD 25" or "USD 24.99". 
   *
   * @generated from enum value: COMPACT_CODE = 5;
   */
  COMPACT_CODE = 5,

  /**
   * * Typical display of dollars only, or dollars and cents, e.g. "+$25" or "+$24.99" no sign is shown with negative numbers. 
   *
   * @generated from enum value: COMPACT_POSITIVE_SIGN_ONLY = 6;
   */
  COMPACT_POSITIVE_SIGN_ONLY = 6,
}

/**
 * Describes the enum squareup.cash.localization.LocalizableString.MoneyFormatter.
 */
export const LocalizableString_MoneyFormatterSchema: GenEnum<LocalizableString_MoneyFormatter> = /*@__PURE__*/
  enumDesc(file_squareup_cash_localization_localization, 0, 0);

/**
 * Represents a string that should be localized or is localized.
 * For newly declared fields that are intended to be human-readable strings, this LocalizedString wrapper should be used.
 *
 * This proto should be used for localizing only sync entities / sync values in the ClientSync service,
 * or localizing protos in requests to postmaster for sending localized messages to customers.
 * The above cases are localized automatically by the ClientSync and Postmaster services.
 * If you need to use this proto anywhere else, they will not be localized automatically.
 * Please ask for help in #cash-localization-eng-help.
 *
 * @generated from message squareup.cash.localization.LocalizedString
 */
export type LocalizedString = Message<"squareup.cash.localization.LocalizedString"> & {
  /**
   * Sets the translated_value field with the value from localizing this string.
   *
   * @generated from field: optional squareup.cash.localization.LocalizableString localizable_string = 1;
   */
  localizableString?: LocalizableString;

  /**
   * Translated string value after localizing localizable_string,
   * or the default fallback en-US string if localization fails for whatever reason.
   *
   * @generated from field: optional string translated_value = 2;
   */
  translatedValue: string;
};

/**
 * Describes the message squareup.cash.localization.LocalizedString.
 * Use `create(LocalizedStringSchema)` to create a new message.
 */
export const LocalizedStringSchema: GenMessage<LocalizedString> = /*@__PURE__*/
  messageDesc(file_squareup_cash_localization_localization, 1);

/**
 * Represents a translation message of any locale.
 *
 * @generated from message squareup.cash.localization.TranslationMessage
 */
export type TranslationMessage = Message<"squareup.cash.localization.TranslationMessage"> & {
  /**
   * The key that uniquely references the translation message within a given client.
   *
   * @generated from field: optional string client_key = 1;
   */
  clientKey: string;

  /**
   * The context of the message that gives more information to a translator on how to approach making a translation.
   *
   * @generated from field: optional string context = 2;
   */
  context: string;

  /**
   * The filepath of where the source locale translation message is located on the client.
   *
   * @generated from field: optional string path = 3;
   */
  path: string;

  /**
   * The actual customer-facing text. Note that this proto does not define which locale this text is using.
   *
   * @generated from field: optional string text = 4;
   */
  text: string;

  /**
   * The version of the key.
   *
   * @generated from field: optional string version_key = 5;
   */
  versionKey: string;
};

/**
 * Describes the message squareup.cash.localization.TranslationMessage.
 * Use `create(TranslationMessageSchema)` to create a new message.
 */
export const TranslationMessageSchema: GenMessage<TranslationMessage> = /*@__PURE__*/
  messageDesc(file_squareup_cash_localization_localization, 2);

/**
 * Maps many translation messages to a single locale.
 *
 * @generated from message squareup.cash.localization.LocaleToTranslationMessages
 */
export type LocaleToTranslationMessages = Message<"squareup.cash.localization.LocaleToTranslationMessages"> & {
  /**
   * @generated from field: optional string locale = 1;
   */
  locale: string;

  /**
   * @generated from field: repeated squareup.cash.localization.TranslationMessage messages = 2;
   */
  messages: TranslationMessage[];
};

/**
 * Describes the message squareup.cash.localization.LocaleToTranslationMessages.
 * Use `create(LocaleToTranslationMessagesSchema)` to create a new message.
 */
export const LocaleToTranslationMessagesSchema: GenMessage<LocaleToTranslationMessages> = /*@__PURE__*/
  messageDesc(file_squareup_cash_localization_localization, 3);

/**
 * Custom field option to indicate that the translated value of a LocalizableString should be set on the given field name.
 * This option exists for the primary benefit of allowing pre-existing human-readable strings that did not use the LocalizedString wrapper to still be able to be replaced with a translated value.
 * If the localization to the translated value fails for whatever reason,
 * the field with the name defined by translated_field_name should be set to the default fallback en-US string.
 *
 * @generated from extension: optional string translated_field_name = 53100;
 */
export const translated_field_name: GenExtension<FieldOptions, string> = /*@__PURE__*/
  extDesc(file_squareup_cash_localization_localization, 0);

